import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // In production you'd send this to Sentry / LogRocket etc.
    if (process.env.NODE_ENV !== 'production') {
      console.error('[SF ErrorBoundary]', error, info);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    const { fallback, inline } = this.props;
    if (fallback) return fallback;

    if (inline) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', padding: '40px 24px', textAlign: 'center',
          color: 'rgba(255,255,255,0.55)', gap: 12,
        }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16" strokeWidth="2.5"/>
          </svg>
          <p style={{ margin: 0, fontSize: 14 }}>Something went wrong here.</p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
              color: '#fff', borderRadius: 6, padding: '6px 16px', cursor: 'pointer', fontSize: 13,
            }}
          >
            Retry
          </button>
        </div>
      );
    }

    return (
      <div style={{
        minHeight: '60vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 16,
        textAlign: 'center', padding: '0 24px',
      }}>
        <div style={{ fontSize: 48, opacity: 0.4 }}>⚠️</div>
        <h2 style={{ color: '#fff', margin: 0, fontSize: 22 }}>Something went wrong</h2>
        <p style={{ color: 'rgba(255,255,255,0.5)', margin: 0, fontSize: 15, maxWidth: 380 }}>
          An unexpected error occurred. Please refresh the page or go back to continue watching.
        </p>
        <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#FF0A7A', border: 'none', color: '#fff',
              borderRadius: 8, padding: '10px 24px', cursor: 'pointer',
              fontSize: 14, fontWeight: 600, fontFamily: 'inherit',
            }}
          >
            Refresh Page
          </button>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)',
              color: '#fff', borderRadius: 8, padding: '10px 24px', cursor: 'pointer',
              fontSize: 14, fontFamily: 'inherit',
            }}
          >
            Go Home
          </button>
        </div>
      </div>
    );
  }
}
